import styled from 'styled-components'

import { breakpoints } from '@/config/layout'

const ContentGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 100%;
  grid-template-areas: 'content';

  width: 100%;
  height: 100%;
  background-color: ${({ theme }) => theme.Colors.Background.Light};

  @media ${breakpoints.s} {
    grid-template-columns: 1fr;
    grid-template-areas: 'content';
  }

  @media ${breakpoints.m} {
    grid-template-columns: 1fr 1fr;
    grid-template-areas: 'content content-detail';
  }

  @media ${breakpoints.l} {
    grid-template-columns: 2fr 3fr;
    grid-template-areas: 'content content-detail';
  }
`

const ContentGridHalf = styled.div<{ withDetail: boolean }>`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-areas: 'content';

  min-height: 0;
  width: 100%;
  height: 100%;
  background-color: ${({ theme }) => theme.Colors.Background.White};

  @media ${breakpoints.s} {
    grid-template-columns: 1fr;
    grid-template-areas: 'content';
    background-color: ${({ theme }) => theme.Colors.Background.Light};
  }

  @media ${breakpoints.m} {
    grid-template-columns: 1fr 1fr;
    grid-template-areas: ${({ withDetail }) => (withDetail ? '"content content-detail"' : '"content content"')};
  }
`

export { ContentGrid, ContentGridHalf }
